import SidebarToggleButton from './SidebarToggleButton'
import Sidebar from './Sidebar'

export default Object.assign(Sidebar, {
  Toggle: SidebarToggleButton,
})
